import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import Axios from "../helpers/interceptor";
const $http = Axios(store);

Vue.use(Vuex);
axios.defaults.baseURL = "https://api.ardunic.com/v1";

export const store = new Vuex.Store({
  state: {
    token: localStorage.getItem("token") || null,
    counter: 0,
    totalPrice: 0,
    profile: {},
  },
  getters: {
    loggedIn: (state) => !!state.token,
    getToken: ({ token }) => token,
    getCounter: ({ counter }) => counter,
    getTotalPrice: ({ totalPrice }) => totalPrice,
    getProfile: ({ profile }) => profile,
  },
  mutations: {
    retrieveToken(state, token) {
      state.token = token;
    },
    destroyToken(state) {
      state.token = null;
    },
    setCounter(state, payload) {
      if (payload.softAdd) state.counter += payload.qty;
      else state.counter = payload.qty;
    },
    setTotalPrice(state, payload) {
      if (payload.softAdd) state.totalPrice += payload.price;
      else state.totalPrice = payload.price;
    },
    setProfile(state, payload) {
      state.profile = payload;
    },
  },
  actions: {
    destroyToken(context) {
      if (context.getters.loggedIn) {
        localStorage.removeItem("token");
        context.commit("destroyToken");
      }
    },
    async login(context, credentials) {
      try {
        const response = await $http.post("/login", {
          phone: credentials.email,
          password: credentials.password,
          playerId: "12",
        });
        const token = response.data.data.token;
        localStorage.setItem("token", token);
        context.commit("retrieveToken", token);
        window.location.href = "/";
      } catch (err) {
        throw err;
      }
    },
    signup(context, credentials) {
      return new Promise((resolve, reject) => {
        axios
          .post("/registration", {
            name: credentials.name,
            password: credentials.password,
            email: credentials.email,
            phone: credentials.phone,
            role: credentials.role,
            reCaptchaToken: credentials.reCaptchaToken,
          })
          .then((response) => {
            // const token = response.data.data.token;
            // localStorage.setItem("token", token);
            // context.commit("retrieveToken", token);
            resolve(response);
            // console.log(token);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    addToCart(context, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            "/cart",
            {
              productId: data.productId,
              totalQuantities: data.totalQuantities,
              priceIds: data.priceIds,
            },
            {
              headers: {
                access_token: localStorage.getItem("token"),
              },
            }
          )
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    addToCardIncrease({ commit }, { qty, price, softAdd = false }) {
      commit("setCounter", { qty, softAdd });
      commit("setTotalPrice", { price, softAdd });
    },
    verifyUser({ commit }, { token }) {
      localStorage.setItem("token", token);
      commit("retrieveToken", token);
    },
    initProfile({ commit }, payload) {
      commit("setProfile", payload);
    },
  },
});

//028364
